import React, { useEffect, useRef, useState } from "react";
import "./styles.scss";
import "./mobile.scss";
import { Button, FormHeader, Tag } from "..";
import { getLanguage } from "../../utils/environment";
import moment from "moment";
import { GetIconByName } from "../../config/icon";
import { MdOutlineFileDownload } from "react-icons/md";
import { useDispatch, useSelector } from "react-redux";
import { notification } from "antd";
import RelatedNews from "../../containers/templates/relatedNews";
import { withRouter } from "react-router-dom/cjs/react-router-dom.min";
import GazetteViewCard from "../gazetteViewCard";
import { getGazetteByGazetteDate } from "../../containers/CreateNewItem/CreateNewGazette/service/jobs.service";
import { setGazetteList } from "../../containers/Jobs/redux/actions";
import { getInsight, setInsight } from "../../utils";
import { addNewGazetteImpression } from "../../containers/GovernmentJobsPage/service/jobs.service";
import { createNewInsight } from "../../containers/console/services/insight.service";
import { useHistory } from "react-router-dom/cjs/react-router-dom";

const lan = getLanguage();

const Index = ({
  data,
  onClickDetailsSI,
  onClickDetailsEN,
  onClickDetailsTA,
  onClickDownloadSI,
  onClickDownloadEN,
}) => {
  const { tagsList } = useSelector(({ tagsReducer }) => tagsReducer);
  let inputElementDownload = null;
  let inputElementOnline = null;
  let inputElementModel = null;

  const [isLoading, setIsLoading] = React.useState(false);
  const [showFull, setShowFull] = useState(false);
  const [isOverflow, setIsOverflow] = useState(false);
  const [selectGazette, setSelectGazette] = useState("");
  const contentRef = useRef(null);

  const history = useHistory();
  const dispatch = useDispatch();
  const { gazetteList } = useSelector(({ jobsReducer }) => jobsReducer);
  console.log("gazettteList", gazetteList);

  const handleCopy = (actualUrl) => {
    navigator.clipboard.writeText(actualUrl).then(() => {
      notification.success({ message: "Link copied to clipboard!" });
    });
  };

  const fetchTagsName = (id) => {
    const isName = tagsList?.find((x) => x?.tag_id === id);
    // console.log("tags name", isName);
    return isName?.tag_name;
  };
  // async function handleInsight(gazetteId) {
  //   let insightBody = {};
  //   try {
  //     console.log({ gazetteId });
  //     // Get the geolocation
  //     // const position = await getGeoLocation();
  //     // const { latitude, longitude, accuracy, timestamp } = position?.coords;

  //     // Wait for all promises to resolve
  //     const [ip] = await Promise.all([
  //       // getLocationName(latitude, longitude),
  //       getIPAddress(),
  //     ]);

  //     // Construct the insight body
  //     insightBody = {
  //       insight_id: null,
  //       ip,
  //       platform: "https://sinhala.hopeofanewera.org/",
  //       // user: sessionUser?.userId,
  //     };

  //     const insight = await getInsight();
  //     // Additional logic for when the insight is found
  //     if (insight?.insight_id) {
  //       console.log("userInsight_insight_found", insight);
  //       insightBody.insight_id = insight.insight_id;
  //       let impressionBody = {
  //         insight_id: insight.insight_id,
  //         gazette_id: gazetteId,
  //         ip_address: ip,
  //       };

  //       let resImpression = await addNewGazetteImpression(impressionBody);
  //       console.log("addNew_Job_Impression::", resImpression);
  //       // setNews({ ...news, views: (news?.views || 0) + 1 });
  //     }
  //   } catch (error) {
  //     console.log("No insight found", error);
  //     try {
  //       const insightResponse = await createNewInsight(insightBody);
  //       console.log("Created new insight:", insightResponse);
  //       if (
  //         insightResponse?.data?.status ||
  //         insightResponse?.data?.data !== ""
  //       ) {
  //         await setInsight(insightResponse?.data?.data?.token);
  //         let impressionBody = {
  //           insight_id: insightResponse?.data?.data?.insight_id,
  //           gazette_id: gazetteId,
  //           ip_address: insightBody.ip,
  //         };

  //         let resImpression = await addNewGazetteImpression(impressionBody);
  //         console.log("addNew_Job_Impression::", resImpression);
  //         // setNews({ ...news, views: (news?.views || 0) + 1 });
  //       }

  //       // Additional logic for when the insight is not found and a new one is created
  //     } catch (creationError) {
  //       console.error("Error creating new insight:", creationError);
  //       // Handle the error that occurred during the creation of a new insight
  //     }
  //   }
  // }

  const openWindow = async (imgUrl, gazette_id) => {
    const adUrlRight = process.env.REACT_APP_HOME_TOP_RIGHT_ADV;
    const adUrlLeft = process.env.REACT_APP_HOME_TOP_LEFT_ADV;

    const insight = await getInsight(); // Assuming this returns { insight_id }
    // try {
    //   await handleInsight(gazette_id);
    // } catch (error) {
    //   console.log(error);
    // }

    // const isPdf = imgUrl.endsWith(".pdf");
    let previewElement = "";
    console.log("Array.isArray(imgUrl)", Array.isArray(imgUrl));
    if (Array.isArray(imgUrl)) {
      previewElement = imgUrl
        .map((img, id) => {
          const src = img?.file_url;
          if (src?.endsWith(".pdf")) {
            return `<iframe src="${src}" alt="${id}" class="responsive-content"></iframe>`;
          } else {
            return `<img src="${src}" alt="${id}" class="responsive-content" />`;
          }
        })
        .join("");
    } else {
      previewElement = imgUrl?.endsWith(".pdf")
        ? `<iframe src="${imgUrl}" alt="PDF" class="responsive-content"></iframe>`
        : `<img src="${imgUrl}" alt="job details sinhala" class="responsive-content" />`;
    }

    const newWindow = window.open("", "", "width=1024,height=920");
    if (newWindow) {
      const safeAdUrlRight = adUrlRight || "";
      const safeAdUrlLeft = adUrlLeft || "";

      newWindow.document.write(`
      <html>
        <head>
          <title>Preview</title>
          <style>
            html, body {
              margin: 0;
              padding: 0;
              height: 100%;
              width: 100%;
              box-sizing: border-box;
              display: flex;
              flex-direction: column;
            }
  
            .advertisement-wrapper {
              display: flex;
              flex-direction: row;
              justify-content: center;
              gap: 10px;
              height: 80px;
              flex-shrink: 0;
            }
  
            .top-ad {
              flex: 1;
              height: 100%;
            }
  
            .top-ad iframe {
              width: 100%;
              height: 100%;
              border: none;
            }
  
            .content-container {
              flex: 1;
              /*overflow: auto;*/
              display: flex;
              justify-content: center;
              align-items: center;
              background: #f8f8f8;
            }
  
            .responsive-content {
              max-width: 100%;
              max-height: 100%;
              width: 100%;
              height: 100%;
              object-fit: contain;
              border: none;
            }
          </style>
        </head>
        <body>
          <div class="advertisement-wrapper">
            <div class="top-ad">
              <iframe id="adFrameLeft" src="${safeAdUrlLeft}" loading="lazy"></iframe>
            </div>
            <div class="top-ad">
              <iframe id="adFrameRight" src="${safeAdUrlRight}" loading="lazy"></iframe>
            </div>
          </div>
          <div class="content-container"  style="display: flex; flex-direction: column;">
            ${previewElement}
          </div>
          <script>
            window.addEventListener('load', function () {
              const iframeLeft = document.getElementById('adFrameLeft');
              const iframeRight = document.getElementById('adFrameRight');
  
              iframeLeft?.addEventListener('load', function () {
                iframeLeft.contentWindow?.postMessage(
                  { insight_id: "${insight?.insight_id || ""}" },
                  "${safeAdUrlLeft}"
                );
              });
  
              iframeRight?.addEventListener('load', function () {
                iframeRight.contentWindow?.postMessage(
                  { insight_id: "${insight?.insight_id || ""}" },
                  "${safeAdUrlRight}"
                );
              });
            });
          </script>
        </body>
      </html>
    `);
      newWindow.document.close();
    }
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const getList = await getGazetteByGazetteDate(data.gazetteDate);
        console.log("Get Gazette : ", getList);

        if (getList.data) {
          console.log("getlistgazette", getList.data.gazette);
          dispatch(setGazetteList(getList.data.gazette));

          setSelectGazette(data.gazette_id);
        } else {
          console.log("Data Not Found");
        }
      } catch (error) {
        console.log("Error fetching Data", error);
      }
    };
    if (data?.gazetteDate) {
      fetchData();
    }
  }, [data.gazetteDate]);

  useEffect(() => {
    if (contentRef.current) {
      setIsOverflow(contentRef.current.scrollHeight > 80); // 80px ~ 3 lines
    }
  }, [data?.description]);

  // inputElementDownload = (
  //   <>
  //     <div className={"jvcmw__cb-action d-flex flex-column"}>
  //       {data?.description && (
  //         <>
  //           <div
  //             ref={contentRef}
  //             className="jvcmw_descritpion"
  //             style={{
  //               maxHeight: showFull ? "none" : "180px",
  //               overflow: "hidden",
  //               // fontSize: "10px",
  //               // color: "black",
  //               transition: showFull ? "max-height 0.3s ease" : "",
  //               position: "relative",
  //             }}
  //             // dangerouslySetInnerHTML={{ __html: data.description }}
  //           >
  //             <div dangerouslySetInnerHTML={{ __html: data.description }} />

  //             {/* Fade-out effect at bottom */}
  //             {isOverflow && !showFull && (
  //               <div
  //                 style={{
  //                   position: "absolute",
  //                   bottom: 0,
  //                   left: 0,
  //                   right: 0,
  //                   height: "40px",
  //                   background:
  //                     "linear-gradient(to top, white, rgba(255,255,255,0))", // adjust "white" to your container background
  //                 }}
  //               />
  //             )}
  //           </div>

  //           {isOverflow && (
  //             <div
  //               className="loading-more"
  //               style={{ marginTop: "5px", marginBottom: "20px" }}
  //             >
  //               <Button
  //                 data={{
  //                   btnName: showFull ? "Show Less" : "Show More..",
  //                   buttonType: "black-border",
  //                   buttonSize: "xs",
  //                   isLoading: isLoading,
  //                   showMore: showFull ? false : true,
  //                   btnIcon: GetIconByName("arrow-down"),
  //                 }}
  //                 // onClick={() => setShowFull((prev) => !prev)}
  //                 onClick={() => {
  //                   setShowFull((prev) => {
  //                     if (prev) {
  //                       // Going from "Show Full" -> "Show Less"
  //                       window.scrollTo({ top: 0, behavior: "smooth" }); // matches transition time
  //                     }
  //                     return !prev;
  //                   });
  //                 }}
  //               />
  //             </div>
  //           )}
  //         </>
  //       )}

  //       {(data?.contactNo || data?.email) && (
  //         <div className={`jvcmw__cba-contact d-flex flex-row`}>
  //           {data?.contactNo && (
  //             <div
  //               className={
  //                 "d-flex flex-row justify-content-center align-items-center"
  //               }
  //             >
  //               <div className={`jvcmw__cbac-icon`}>
  //                 {GetIconByName("phone")}
  //               </div>
  //               <div className={"d-flex flex-column"}>
  //                 <span className={`jvcmw__cbac-title`}>Contact No</span>
  //                 <div className={`jvcmw__cbac-mobile`}>
  //                   {" "}
  //                   {data?.contactNo}
  //                   <span
  //                     className="jcm_copy ml-2"
  //                     style={{ cursor: "pointer" }}
  //                     onClick={() => handleCopy(data?.contactNo)}
  //                   >
  //                     {GetIconByName("copy")}
  //                   </span>
  //                 </div>
  //               </div>
  //             </div>
  //           )}

  //           {data?.email && (
  //             <div
  //               className={
  //                 "d-flex flex-row justify-content-center align-items-center"
  //               }
  //             >
  //               <div className={`jvcmw__cbac-icon`}>
  //                 {GetIconByName("mail")}
  //               </div>
  //               <div className={"d-flex flex-column"}>
  //                 <span className={`jvcmw__cbac-title`}>Email</span>
  //                 <div className={`jvcmw__cbac-mail`}>
  //                   {" "}
  //                   {data?.email}
  //                   <span
  //                     className="jcm_copy ml-2"
  //                     style={{ cursor: "pointer" }}
  //                     onClick={() => handleCopy(data?.email)}
  //                   >
  //                     {GetIconByName("copy")}
  //                   </span>
  //                 </div>
  //               </div>
  //             </div>
  //           )}
  //         </div>
  //       )}

  //       {(data?.job_si?.length > 0 ||
  //         data?.job_en?.length > 0 ||
  //         data?.job_ta?.length > 0) && (
  //         <div
  //           className="jvcmw__cba-download"
  //           style={{ marginTop: "8px", marginBottom: "12px" }}
  //         >
  //           <div className="jvcmw__cbad-title">Job details (png)</div>
  //           <div className="d-flex flex-row" style={{ gap: "8px" }}>
  //             {data?.job_si?.length > 0 && (
  //               <Button
  //                 data={{
  //                   btnName: "SINHALA",
  //                   buttonType: "black-border",
  //                   buttonSize: "xs",
  //                   isLoading: false,
  //                 }}
  //                 onClick={onClickDetailsSI}
  //               />
  //             )}
  //             {data?.job_ta?.length > 0 && (
  //               <Button
  //                 data={{
  //                   btnName: "TAMIL",
  //                   buttonType: "black-border",
  //                   buttonSize: "xs",
  //                   isLoading: false,
  //                 }}
  //                 onClick={onClickDetailsTA}
  //               />
  //             )}
  //             {data?.job_en?.length > 0 && (
  //               <Button
  //                 data={{
  //                   btnName: "ENGLISH",
  //                   buttonType: "black-border",
  //                   buttonSize: "xs",
  //                   isLoading: false,
  //                 }}
  //                 onClick={onClickDetailsEN}
  //               />
  //             )}
  //           </div>
  //         </div>
  //       )}

  //       <div className={`jvcmw__cba-download`}>
  //         <div className={`jvcmw__cbad-title`}>
  //           Download applications (PDF, DOCX)
  //         </div>
  //         <div className={`d-flex flex-row`} style={{ gap: "8px" }}>
  //           {data?.jobApplicationSI && (
  //             <Button
  //               data={{
  //                 btnName: "SINHALA",
  //                 buttonType: "black-border",
  //                 buttonSize: "xs",
  //                 isLoading: data?.isLoading,
  //               }}
  //               onClick={onClickDownloadSI}
  //             />
  //           )}
  //           {data?.jobApplicationEN && (
  //             <Button
  //               data={{
  //                 btnName: "ENGLISH",
  //                 buttonType: "black-border",
  //                 buttonSize: "xs",
  //                 isLoading: data?.isLoading,
  //               }}
  //               onClick={onClickDownloadEN}
  //             />
  //           )}
  //         </div>
  //       </div>
  //     </div>
  //   </>
  // );

  // inputElementOnline = (
  //   <>
  //     <div className={"jvcmw__cb-action d-flex flex-column"}>
  //       {data?.description && (
  //         <div>
  //           <div
  //             ref={contentRef}
  //             className="jvcmw_descritpion"
  //             style={{
  //               maxHeight: showFull ? "none" : "180px",
  //               overflow: "hidden",
  //               fontSize: "12px",
  //               color: "black",
  //               transition: showFull ? "max-height 0.3s ease" : "",
  //               position: "relative",
  //             }}
  //             dangerouslySetInnerHTML={{ __html: data.description }}
  //           />

  //           {isOverflow && !showFull && (
  //             <div
  //               style={{
  //                 position: "relative",
  //                 marginTop: "-50px",
  //                 height: "50px",
  //                 background:
  //                   "linear-gradient(to top, white, rgba(255, 255, 255, 0))", // adjust colors for your theme
  //               }}
  //             />
  //           )}

  //           {isOverflow && (
  //             <div
  //               className="loading-more"
  //               style={{ marginTop: "5px", marginBottom: "20px" }}
  //             >
  //               <Button
  //                 data={{
  //                   btnName: showFull ? "Show Less" : "Show More..",
  //                   buttonType: "black-border",
  //                   buttonSize: "xs",
  //                   isLoading: isLoading,
  //                   showMore: showFull ? false : true,
  //                   btnIcon: GetIconByName("arrow-down"),
  //                 }}
  //                 // onClick={() => setShowFull((prev) => !prev)}
  //                 onClick={() => {
  //                   setShowFull((prev) => {
  //                     if (prev) {
  //                       // Going from "Show Full" -> "Show Less"
  //                       window.scrollTo({ top: 0, behavior: "smooth" }); // matches transition time
  //                     }
  //                     return !prev;
  //                   });
  //                 }}
  //                 w
  //               />
  //             </div>
  //           )}
  //         </div>
  //       )}

  //       <div className={`jvcmw__cba-source`}>
  //         Source :
  //         <span
  //           style={{
  //             color: "#3C71E4",
  //             textDecoration: "underline",
  //             cursor: "pointer",
  //           }}
  //           onClick={() => window.open(data?.sourceUrl)}
  //         >
  //           {data?.sourceUrl}
  //         </span>
  //       </div>

  //       {(data?.contactNo || data?.email) && (
  //         <div className={`jvcmw__cba-contact d-flex flex-row`}>
  //           {data?.contactNo && (
  //             <div
  //               className={
  //                 "d-flex flex-row justify-content-center align-items-center"
  //               }
  //             >
  //               <div className={`jvcmw__cbac-icon`}>
  //                 {GetIconByName("phone")}
  //               </div>
  //               <div className={"d-flex flex-column"}>
  //                 <span className={`jvcmw__cbac-title`}>Contact No</span>
  //                 <div className={`jvcmw__cbac-mobile`}>
  //                   {" "}
  //                   {data.contactNo}
  //                   <span
  //                     className="jcm_copy ml-2"
  //                     style={{ cursor: "pointer" }}
  //                     onClick={() => handleCopy(data?.contactNo)}
  //                   >
  //                     {GetIconByName("copy")}
  //                   </span>
  //                 </div>
  //               </div>
  //             </div>
  //           )}

  //           {data?.email && (
  //             <div
  //               className={
  //                 "d-flex flex-row justify-content-center align-items-center"
  //               }
  //             >
  //               <div className={`jvcmw__cbac-icon`}>
  //                 {GetIconByName("mail")}
  //               </div>
  //               <div className={"d-flex flex-column"}>
  //                 <span className={`jvcmw__cbac-title`}>Email</span>
  //                 <div className={`jvcmw__cbac-mail`}>
  //                   {" "}
  //                   {data?.email}
  //                   <span
  //                     className="jcm_copy ml-2"
  //                     style={{ cursor: "pointer" }}
  //                     onClick={() => handleCopy(data?.email)}
  //                   >
  //                     {GetIconByName("copy")}
  //                   </span>
  //                 </div>
  //               </div>
  //             </div>
  //           )}
  //         </div>
  //       )}

  //       {(data?.job_si?.length > 0 ||
  //         data?.job_en?.length > 0 ||
  //         data?.job_ta?.length > 0) && (
  //         <div
  //           className="jvcmw__cba-download"
  //           style={{ marginTop: "8px", marginBottom: "12px" }}
  //         >
  //           <div className="jvcmw__cbad-title">Job details (png)</div>
  //           <div className="d-flex flex-row" style={{ gap: "8px" }}>
  //             {data?.job_si?.length > 0 && (
  //               <Button
  //                 data={{
  //                   btnName: "SINHALA",
  //                   buttonType: "black-border",
  //                   buttonSize: "xs",
  //                   isLoading: false,
  //                 }}
  //                 onClick={onClickDetailsSI}
  //               />
  //             )}
  //             {data?.job_ta?.length > 0 && (
  //               <Button
  //                 data={{
  //                   btnName: "TAMIL",
  //                   buttonType: "black-border",
  //                   buttonSize: "xs",
  //                   isLoading: false,
  //                 }}
  //                 onClick={onClickDetailsTA}
  //               />
  //             )}
  //             {data?.job_en?.length > 0 && (
  //               <Button
  //                 data={{
  //                   btnName: "ENGLISH",
  //                   buttonType: "black-border",
  //                   buttonSize: "xs",
  //                   isLoading: false,
  //                 }}
  //                 onClick={onClickDetailsEN}
  //               />
  //             )}
  //           </div>
  //         </div>
  //       )}

  //       <div className={`jvcmw__cba-download`} style={{ marginBottom: "12px" }}>
  //         <div className={`jvcmw__cbad-title`}>Apply for online</div>
  //         <div className={`d-flex flex-row`} style={{ gap: "8px" }}>
  //           <Button
  //             data={{
  //               btnName: "ONLINE APPLICATION",
  //               buttonType: "black-border",
  //               buttonSize: "xs",
  //               isLoading: data?.isLoading,
  //             }}
  //             onClick={() => window.open(data?.sourceUrl)}
  //           />
  //         </div>
  //       </div>

  //       {/* tags */}
  //     </div>
  //   </>
  // );

  // inputElementModel = (
  //   <>
  //     <div className={"jvcmw__cb-action d-flex flex-column"}>
  //       {data?.description && (
  //         <div>
  //           <div
  //             ref={contentRef}
  //             className="jvcmw_descritpion"
  //             style={{
  //               maxHeight: showFull ? "none" : "180px",
  //               overflow: "hidden",
  //               fontSize: "12px",
  //               color: "#c2c2c2",
  //               transition: showFull ? "max-height 0.3s ease" : "",
  //               position: "relative",
  //             }}
  //             dangerouslySetInnerHTML={{ __html: data.description }}
  //           />

  //           {isOverflow && !showFull && (
  //             <div
  //               style={{
  //                 position: "relative",
  //                 marginTop: "-50px",
  //                 height: "50px",
  //                 background:
  //                   "linear-gradient(to top, white, rgba(255, 255, 255, 0))", // adjust colors for your theme
  //               }}
  //             />
  //           )}

  //           {isOverflow && (
  //             <div
  //               className="loading-more"
  //               style={{ marginTop: "5px", marginBottom: "20px" }}
  //             >
  //               <Button
  //                 data={{
  //                   btnName: showFull ? "Show Less" : "Show More..",
  //                   buttonType: "black-border",
  //                   buttonSize: "xs",
  //                   isLoading: isLoading,
  //                   showMore: showFull ? false : true,
  //                   btnIcon: GetIconByName("arrow-down"),
  //                 }}
  //                 // onClick={() => setShowFull((prev) => !prev)}
  //                 onClick={() => {
  //                   setShowFull((prev) => {
  //                     if (prev) {
  //                       // Going from "Show Full" -> "Show Less"
  //                       window.scrollTo({ top: 0, behavior: "smooth" }); // matches transition time
  //                     }
  //                     return !prev;
  //                   });
  //                 }}
  //               />
  //             </div>
  //           )}
  //         </div>
  //       )}

  //       <div className={`jvcmw__cba-source`}>
  //         Source :
  //         <span
  //           style={{
  //             color: "#3C71E4",
  //             textDecoration: "underline",
  //             cursor: "pointer",
  //           }}
  //           onClick={() => window.open(data?.sourceUrl)}
  //         >
  //           {data?.sourceUrl}
  //         </span>
  //       </div>
  //       {(data?.contactNo || data?.email) && (
  //         <div className={`jvcmw__cba-contact d-flex flex-row`}>
  //           {data?.contactNo && (
  //             <div
  //               className={
  //                 "d-flex flex-row justify-content-center align-items-center"
  //               }
  //             >
  //               <div className={`jvcmw__cbac-icon`}>
  //                 {GetIconByName("phone")}
  //               </div>
  //               <div className={"d-flex flex-column"}>
  //                 <span className={`jvcmw__cbac-title`}>Contact No</span>
  //                 <div className={`jvcmw__cbac-mobile`}>
  //                   {data?.contactNo}
  //                   <span
  //                     className="jcm_copy ml-2"
  //                     style={{ cursor: "pointer" }}
  //                     onClick={() => handleCopy(data?.contactNo)}
  //                   >
  //                     {GetIconByName("copy")}
  //                   </span>
  //                 </div>
  //               </div>
  //             </div>
  //           )}

  //           {data?.email && (
  //             <div
  //               className={
  //                 "d-flex flex-row justify-content-center align-items-center"
  //               }
  //             >
  //               <div className={`jvcmw__cbac-icon`}>
  //                 {GetIconByName("mail")}
  //               </div>
  //               <div className={"d-flex flex-column"}>
  //                 <span className={`jvcmw__cbac-title`}>Email</span>
  //                 <div className={`jvcmw__cbac-mail`}>
  //                   {data?.email}
  //                   <span
  //                     className="jcm_copy ml-2"
  //                     style={{ cursor: "pointer" }}
  //                     onClick={() => handleCopy(data?.email)}
  //                   >
  //                     {GetIconByName("copy")}
  //                   </span>
  //                 </div>
  //               </div>
  //             </div>
  //           )}
  //         </div>
  //       )}
  //       <div className={`jvcmw__cba-download`}>
  //         <div className={`jvcmw__cbad-title`}>
  //           Download applications (PDF, DOCX)
  //         </div>
  //         <div className={`d-flex flex-row`} style={{ gap: "8px" }}>
  //           <Button
  //             data={{
  //               btnName: "MODEL APPPLICATION",
  //               buttonType: "black",
  //               buttonSize: "xs",
  //               isLoading: data?.isLoading,
  //             }}
  //             onClick={onClickDownloadSI}
  //           />
  //         </div>
  //       </div>

  //       {(data?.job_si?.length > 0 ||
  //         data?.job_en?.length > 0 ||
  //         data?.job_ta?.length > 0) && (
  //         <div
  //           className="jvcmw__cba-download"
  //           style={{ marginTop: "8px", marginBottom: "12px" }}
  //         >
  //           <div className="jvcmw__cbad-title">Job details (png)</div>
  //           <div className="d-flex flex-row" style={{ gap: "8px" }}>
  //             {data?.job_si?.length > 0 && (
  //               <Button
  //                 data={{
  //                   btnName: "SINHALA",
  //                   buttonType: "black-border",
  //                   buttonSize: "xs",
  //                   isLoading: false,
  //                 }}
  //                 onClick={onClickDetailsSI}
  //               />
  //             )}
  //             {data?.job_ta?.length > 0 && (
  //               <Button
  //                 data={{
  //                   btnName: "TAMIL",
  //                   buttonType: "black-border",
  //                   buttonSize: "xs",
  //                   isLoading: false,
  //                 }}
  //                 onClick={onClickDetailsTA}
  //               />
  //             )}
  //             {data?.job_en?.length > 0 && (
  //               <Button
  //                 data={{
  //                   btnName: "ENGLISH",
  //                   buttonType: "black-border",
  //                   buttonSize: "xs",
  //                   isLoading: false,
  //                 }}
  //                 onClick={onClickDetailsEN}
  //               />
  //             )}
  //           </div>
  //         </div>
  //       )}

  //       {Array.isArray(data?.tags) && data.tags.length > 0 && (
  //         <div className="d-flex flex-wrap" style={{ gap: "4px" }}>
  //           {data.tags.map((tagId, index) => {
  //             const tagData = tagsList.find((t) => t.tag_id === tagId);
  //             return (
  //               <Tag
  //                 key={index}
  //                 data={{
  //                   isIcon: false,
  //                   type: "gray",
  //                   tagName: tagData?.tag_name || "",
  //                 }}
  //               />
  //             );
  //           })}
  //         </div>
  //       )}
  //     </div>
  //   </>
  // );

  return (
    <>
      <div className={`jobs-view-card-main-wrp ${data.type}`}>
        <div className={`jvcmw__card d-flex flex-row`}>
          <div className={"jvcmw__c-body"}>
            <div className={"d-flex align-items-center jvcmw__header"}>
              <div className={"jvcmw__c-img"}>
                <img src={data?.imgUrl} alt={"job-img"} />
              </div>
              <div className={"job-view-header-wrapper"}>
                <FormHeader
                  data={{
                    // formHeader: "Draughtsman - Survey Department of Sri Lanka",
                    formHeader: data?.titleEn,
                    lan: "en",
                    size: "xs xx",
                  }}
                />
                <FormHeader
                  data={{
                    // formHeader:
                    //   "කෙටුම්පත්කරු කෘෂිකර්ම පශු සම්පත්, ඉඩම් හා වාරිමාර්ග අමාත්‍යංශය",
                    formHeader: data?.titleSi,
                    lan: "si",
                    size: "xs xx",
                  }}
                />
              </div>
            </div>
            {/* {data.type === "download" && <>{inputElementDownload}</>}
            {data.type === "online" && <>{inputElementOnline}</>}
            {data.type === "model" && <>{inputElementModel}</>} */}

            <div className={"jvcmw__cb-action d-flex flex-column"}>
              {data?.description && (
                <>
                  <div
                    ref={contentRef}
                    className="jvcmw_descritpion"
                    style={{
                      maxHeight: showFull ? "none" : "180px",
                      overflow: "hidden",
                      // fontSize: "10px",
                      // color: "black",
                      transition: showFull ? "max-height 0.3s ease" : "",
                      position: "relative",
                    }}
                    // dangerouslySetInnerHTML={{ __html: data.description }}
                  >
                    <div
                      dangerouslySetInnerHTML={{ __html: data.description }}
                    />

                    {/* Fade-out effect at bottom */}
                    {isOverflow && !showFull && (
                      <div
                        style={{
                          position: "absolute",
                          bottom: 0,
                          left: 0,
                          right: 0,
                          height: "40px",
                          background:
                            "linear-gradient(to top, white, rgba(255,255,255,0))", // adjust "white" to your container background
                        }}
                      />
                    )}
                  </div>

                  {isOverflow && (
                    <div
                      className="loading-more"
                      style={{ marginTop: "5px", marginBottom: "20px" }}
                    >
                      <Button
                        data={{
                          btnName: showFull ? "Show Less" : "Show More..",
                          buttonType: "black-border",
                          buttonSize: "xs",
                          isLoading: isLoading,
                          showMore: showFull ? false : true,
                          btnIcon: GetIconByName("arrow-down"),
                        }}
                        // onClick={() => setShowFull((prev) => !prev)}
                        onClick={() => {
                          setShowFull((prev) => {
                            if (prev) {
                              // Going from "Show Full" -> "Show Less"
                              window.scrollTo({ top: 0, behavior: "smooth" }); // matches transition time
                            }
                            return !prev;
                          });
                        }}
                      />
                    </div>
                  )}
                </>
              )}

              {data?.sourceUrl && (
                <div className={`jvcmw__cba-source`}>
                  Source :
                  <span
                    style={{
                      color: "#3C71E4",
                      textDecoration: "underline",
                      cursor: "pointer",
                    }}
                    onClick={() => window.open(data?.sourceUrl)}
                  >
                    {data?.sourceUrl}
                  </span>
                </div>
              )}

              {(data?.contactNo || data?.email) && (
                <div className={`jvcmw__cba-contact d-flex flex-row`}>
                  {data?.contactNo && (
                    <div
                      className={
                        "d-flex flex-row justify-content-center align-items-center"
                      }
                    >
                      <div className={`jvcmw__cbac-icon`}>
                        {GetIconByName("phone")}
                      </div>
                      <div className={"d-flex flex-column"}>
                        <span className={`jvcmw__cbac-title`}>Contact No</span>
                        <div className={`jvcmw__cbac-mobile`}>
                          {" "}
                          {data?.contactNo}
                          <span
                            className="jcm_copy ml-2"
                            style={{ cursor: "pointer" }}
                            onClick={() => handleCopy(data?.contactNo)}
                          >
                            {GetIconByName("copy")}
                          </span>
                        </div>
                      </div>
                    </div>
                  )}

                  {data?.email && (
                    <div
                      className={
                        "d-flex flex-row justify-content-center align-items-center"
                      }
                    >
                      <div className={`jvcmw__cbac-icon`}>
                        {GetIconByName("mail")}
                      </div>
                      <div className={"d-flex flex-column"}>
                        <span className={`jvcmw__cbac-title`}>Email</span>
                        <div className={`jvcmw__cbac-mail`}>
                          {" "}
                          {data?.email}
                          <span
                            className="jcm_copy ml-2"
                            style={{ cursor: "pointer" }}
                            onClick={() => handleCopy(data?.email)}
                          >
                            {GetIconByName("copy")}
                          </span>
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              )}

              {(data?.job_si?.length > 0 ||
                data?.job_en?.length > 0 ||
                data?.job_ta?.length > 0) && (
                <div
                  className="jvcmw__cba-download"
                  style={{ marginTop: "8px", marginBottom: "12px" }}
                >
                  <div className="jvcmw__cbad-title">Job details (png)</div>
                  <div className="jvcmw_cbad-button" style={{ gap: "8px" }}>
                    {data?.job_si?.length > 0 && (
                      <Button
                        data={{
                          btnName: "SINHALA",
                          buttonType: "black-border",
                          buttonSize: "xs",
                          isLoading: false,
                        }}
                        onClick={onClickDetailsSI}
                      />
                    )}
                    {data?.job_ta?.length > 0 && (
                      <Button
                        data={{
                          btnName: "TAMIL",
                          buttonType: "black-border",
                          buttonSize: "xs",
                          isLoading: false,
                        }}
                        onClick={onClickDetailsTA}
                      />
                    )}
                    {data?.job_en?.length > 0 && (
                      <Button
                        data={{
                          btnName: "ENGLISH",
                          buttonType: "black-border",
                          buttonSize: "xs",
                          isLoading: false,
                        }}
                        onClick={onClickDetailsEN}
                      />
                    )}
                  </div>
                </div>
              )}

              {data.type === "download" && (
                <div className={`jvcmw__cba-download`}>
                  <div className={`jvcmw__cbad-title`}>
                    Download applications (PDF, DOCX)
                  </div>
                  <div className={"jvcmw_cbad-button"} style={{ gap: "8px" }}>
                    {data?.jobApplicationSI && (
                      <Button
                        data={{
                          btnName: "SINHALA",
                          buttonType: "black-border",
                          buttonSize: "xs",
                          isLoading: data?.isLoading,
                        }}
                        onClick={onClickDownloadSI}
                      />
                    )}
                    {data?.jobApplicationEN && (
                      <Button
                        data={{
                          btnName: "ENGLISH",
                          buttonType: "black-border",
                          buttonSize: "xs",
                          isLoading: data?.isLoading,
                        }}
                        onClick={onClickDownloadEN}
                      />
                    )}
                  </div>
                </div>
              )}

              {data.type === "online" && data?.sourceUrl && (
                <div
                  className={`jvcmw__cba-download`}
                  style={{ marginBottom: "12px" }}
                >
                  <div className={`jvcmw__cbad-title`}>Apply for online</div>
                  <div className={"jvcmw_cbad-button"} style={{ gap: "8px" }}>
                    <Button
                      data={{
                        btnName: "ONLINE APPLICATION",
                        buttonType: "black-border",
                        buttonSize: "xs",
                        isLoading: data?.isLoading,
                      }}
                      onClick={() => window.open(data?.sourceUrl)}
                    />
                  </div>
                </div>
              )}

              {/* {data.type === "model" && (
              {Array.isArray(data?.tags) && data.tags.length > 0 && (
              <div className="d-flex flex-wrap" style={{ gap: "4px" }}>
              {data.tags.map((tagId, index) => {
              const tagData = tagsList.find((t) => t.tag_id === tagId);
              return (
                <Tag
                  key={index}
                  data={{
                    isIcon: false,
                    type: "gray",
                    tagName: tagData?.tag_name || "",
                  }}
                />
              );
            })}
          </div>
        )}

              )} */}
            </div>

            {/*GazetteViewCard*/}
            {data.gazetteDate && gazetteList?.[0] && (
              <div className="jvcmw_gazette-card">
                <div className="jvcmw_gc-title">Gazette</div>
                <GazetteViewCard
                  isSelect={selectGazette === gazetteList?.gazette_id}
                  titleEn={
                    "Gazette of the Democratic Socialist Republic of Sri Lanka"
                  }
                  titleSi={
                    "ශ්‍රී ලංකා ප්‍රජාතාන්ත්‍රික සමාජවාදී ජනරජයේ ගැසට් පත්‍ර"
                  }
                  gazetteDate={gazetteList?.[0]?.gazette_date}
                  // cardType={"job"}
                  created_at={gazetteList?.[0]?.created_at}
                  organization={gazetteList?.[0]?.tags}
                  views={gazetteList?.[0]?.views}
                  isArrow={true}
                  // job_si={gazetteList?.[0]?.job_details?.si_url}
                  // job_en={gazetteList?.[0]?.job_details?.en_url}
                  // job_ta={gazetteList?.[0]?.job_details?.ta_url}
                  // onClickDetailsSI={async () => {
                  //   await openWindow(
                  //     gazetteList?.[0]?.job_details?.si_url,
                  //     gazetteList?.[0]?.gazette_id
                  //   );
                  // }}
                  // onClickDetailsEN={async () => {
                  //   await openWindow(
                  //     gazetteList?.[0]?.job_details?.en_url,
                  //     gazetteList?.[0]?.gazette_id
                  //   );
                  // }}
                  // onClickDetailsTA={async () => {
                  //   await openWindow(
                  //     gazetteList?.[0]?.job_details?.ta_url,
                  //     gazetteList?.[0]?.gazette_id
                  //   );
                  // }}
                  onClickView={async () => {
                    setSelectGazette(gazetteList?.[0]?.gazette_id);
                    history.push(
                      `/government-gazette/${moment(
                        gazetteList?.[0]?.gazette_date
                      ).format("YYYY-MM-DD")}/${gazetteList?.[0]?.gazette_id}`
                    );
                  }}
                />
              </div>
            )}

            <div className={"d-flex flex-wrap"} style={{ gap: "4px" }}>
              <Tag
                data={{
                  isIcon: false,
                  // type: "views_tag",
                  type: moment().isAfter(moment(data?.closingDate))
                    ? "red" // or "expired_tag", "red_tag", etc.
                    : "views_tag",
                  // tagName: "Closing date : " + moment().format("DD-MMM-YYYY"),
                  // tagName:
                  //   "Closing date : " +
                  //   moment(data?.closingDate).format("DD-MMM-YYYY"),
                  tagName: moment().isAfter(moment(data?.closingDate))
                    ? "Expired"
                    : "Closing date : " +
                      moment(data?.closingDate).format("DD-MMM-YYYY"),
                }}
              />
              <Tag
                data={{
                  isIcon: false,
                  type: "views_tag",
                  // tagName: data?.tags?.[0],
                  tagName: data?.organization,
                }}
              />
              <Tag
                data={{
                  isIcon: true,
                  tagIcon: "eye",
                  tagName: data?.views,
                  type: "views_tag",
                }}
              />
              <Tag
                data={{
                  isIcon: true,
                  tagIcon: "download",
                  tagName: data?.downloads,
                  type: "views_tag",
                }}
              />
            </div>
          </div>
        </div>{" "}
        {data?.newsList?.length > 0 && (
          <RelatedNews
            newsList={data?.newsList}
            title={"Related articles"}
            news_id={""}
            is_title={false}
          />
        )}
      </div>
    </>
  );
};

export default withRouter(Index);
